import { Component, OnInit } from '@angular/core';
import { FaqDto, FaqService } from '../../services/faq.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {
  faqs: FaqDto[] = [];
  isLoading = false;
  errorMessage = '';
  emptyMessage = 'No FAQs found';

  constructor(private faqService: FaqService) { }

  ngOnInit(): void {
    this.loadFaqs();
  }

  private loadFaqs(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.faqService.getFaqs(1, 10).subscribe({
      next: (response) => {
        this.faqs = response?.faqs || [];
        this.emptyMessage = response?.message || 'No FAQs found';
        this.isLoading = false;
      },
      error: () => {
        this.faqs = [];
        this.errorMessage = 'Unable to load FAQs right now. Please try again later.';
        this.isLoading = false;
      }
    });
  }
}
